export default __webpack_public_path__ + "static/2-aa841d896eaa1a13fb33d923df0dbb32.jpeg";